import React, {useState, useEffect, useRef} from 'react';
import { IoMdSearch } from 'react-icons/io';
import { useStateContext } from '../contexts/ContextProvider';

function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

const Search = ({dataI,sTotalVenta,onValorSeleccionadoChange}) => {
  const { handleClick, isClicked } = useStateContext();
  const [searchTerm, setSearchTerm] = useState('');
  const [results, setResults] = useState('');
  const [shouldFocus, setShouldFocus] = useState(true);

  const inputRef = useRef(null);


    // Función para devolver el foco al campo de entrada después de hacer clic en un componente
    const returnFocusToInput = () => {
      inputRef.current.focus();
    };

  useEffect(() => {
    console.log('Estableciendo enfoque en Search:', shouldFocus);
    if (shouldFocus) {
      inputRef.current.focus(); // Establecer enfoque cuando el componente se monte o cuando shouldFocus sea true
      setShouldFocus(false); // Desactivar el enfoque para evitar que se establezca cada vez que se renderice el componente
    }
  }, [shouldFocus]);

    useEffect(() => {
      const handleKeyDown = (event) => {

         if (event.key === 'Enter') {
          const inputValue = searchTerm.trim().toLowerCase();
          let count = 0;
  
          const firstResult = dataI?.data?.find((suggestion) => {
            const strproductAlias = suggestion.codAlias || '';
            const strproductCode = suggestion.codigoProducto || '';
            const strproductSku = suggestion.sku || '';
      
            const searchRegex = new RegExp(`\\b${escapeRegExp(inputValue)}\\b`, 'i');
      
            const keep =
              count < 40 &&
              (searchRegex.test(strproductAlias) ||
                searchRegex.test(strproductCode) ||
                searchRegex.test(strproductSku));
      
            if (keep) {
              count++;
            }
            return keep;
          });
  
          if (firstResult) {
            handleSelectResult(firstResult);
            setSearchTerm('');

            setShouldFocus(true); // Activar el enfoque para que se establezca después de hacer clic en Enter
               
          }

        }
      };
  
      document.addEventListener('keydown', handleKeyDown);
      return () => {
        document.removeEventListener('keydown', handleKeyDown);
      };
    }, [dataI?.data, handleClick, searchTerm]);
  
  const handleSearch = (event) => {
    const { value } = event.target;
    setSearchTerm(value);
  };

  const handleSelectResult = (result) => {
    onValorSeleccionadoChange(result._id);
    setResults([]);
    setSearchTerm('');
  };

  return (
    <div className="flex justify-start items-center w-full px-2 rounded-md bg-white border-solid outline-none focus-within:shadow-sm">
      <IoMdSearch fontSize={21} className="ml-1 " />
      {/*         onKeyDown={handleKeyDown} */}
      <input
        type="text"
        placeholder="Buscar o Scanear Producto ..."
        className="p-2 text-sm w-full bg-white border-solid border-gray-800 outline-none"
        value={searchTerm}
        onChange={handleSearch}
        ref={inputRef}
        autoFocus
      />
    </div>
  )
}

export default Search